export const convertFormToAnswers = (formData) => {
  const answers = [];

  if (formData.firstName) {
    answers.push({
      question: "ชื่อ",
      key: "firstName",
      answer: formData.firstName,
    });
  }

  if (formData.lastName) {
    answers.push({
      question: "นามสกุล",
      key: "lastName",
      answer: formData.lastName,
    });
  }

  if (formData.gender) {
    answers.push({
      question: "เพศ",
      key: "gender",
      answer: formData.gender,
    });
  }

  if (formData.birthDate) {
    answers.push({
      question: "วันเดือนปี (พ.ศ.) เกิด",
      key: "birthDate",
      answer: formData.birthDate,
    });
  }

  if (formData.status) {
    answers.push({
      question: "สถานภาพ",
      key: "status",
      answer: formData.status,
    });
  }

  if (formData.education) {
    answers.push({
      question: "ระดับการศึกษา",
      key: "education",
      answer: formData.education,
    });
  }

  if (formData.department) {
    answers.push({
      question: "หน่วยงานต้นสังกัด",
      key: "department",
      answer: formData.department,
    });
  }

  if (formData.position) {
    answers.push({
      question: "ตำแหน่ง",
      key: "position",
      answer: formData.position,
    });
  }

  if (formData.roles && formData.roles.length > 0) {
    answers.push({
      question: "สถานะ/บทบาทของท่านในโครงการ",
      key: "roles",
      answer: formData.roles,
    });
  }

  if (formData.roles?.includes("อื่นๆ") && formData.otherRole) {
    answers.push({
      question: "บทบาทอื่นๆ (ระบุ)",
      key: "otherRole",
      answer: formData.otherRole,
    });
  }

  if (formData.healthZone) {
    answers.push({
      question: "เขตสุขภาพ",
      key: "healthZone",
      answer: formData.healthZone,
    });
  }

  if (formData.province) {
    answers.push({
      question: "จังหวัด",
      key: "province",
      answer: formData.province,
    });
  }

  if (formData.district) {
    answers.push({
      question: "อำเภอ",
      key: "district",
      answer: formData.district,
    });
  }

  if (formData.subDistrict) {
    answers.push({
      question: "ตำบล",
      key: "subDistrict",
      answer: formData.subDistrict,
    });
  }

  if (formData.fund) {
    answers.push({
      question: "กองทุน",
      key: "fund",
      answer: formData.fund,
    });
  }

  if (formData.fundTypes && formData.fundTypes.length > 0) {
    answers.push({
      question: "ประเภทของกองทุน",
      key: "fundTypes",
      answer: formData.fundTypes,
    });
  }

  return answers;
};
